import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import WaterLayout from 'water-layout';
import WaterRest from 'water-rest';
import { errorHandler } from 'water-rest/src/service/LoggerService';
import { Fetch } from 'water-rest/src/fetch/Fetch';
import { clearAuthState } from '@/services/auth-service';
import SubMenuEntity from '@/components/menu/SubMenuEntity.vue';
import BaseMenuEntity from '@/components/menu/BaseMenuEntity.vue';
import BaseSideMenuEntity from '@/components/menu/BaseSideMenuEntity.vue';
import SubSideMenuEntity from '@/components/menu/SubSideMenuEntity.vue';
import rir from 'water-layout/src/plugins/RirLib';
import VueYandexMetrika from 'vue-yandex-metrika-ts';

Vue.component('base-menu-entity', BaseMenuEntity);
Vue.component('base-side-menu-entity', BaseSideMenuEntity);
Vue.component('sub-menu-entity', SubMenuEntity);
Vue.component('sub-side-menu-entity', SubSideMenuEntity);

Vue.use(WaterRest, {
  apiBasePath: process.env.VUE_APP_BASE_PATH,
  moduleName: 'shell',
});
Vue.use(WaterLayout);

Vue.config.productionTip = false;
Fetch.setLogout(clearAuthState);

Vue.use(VueYandexMetrika, {
  id: process.env.VUE_APP_METRIKA_API_KEY || 95842024,
  router: router,
  env: process.env.NODE_ENV,
  ignoreRoutes: ['/login', '/download-app']
})

new Vue({
  $rir: rir,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

if (process.env.NODE_ENV !== 'production') {
  (window as any).VUE_DEVTOOLS_CONFIG = {
    customVue2ScanSelector: '#modules-container',
  };
}

if (process.env.NODE_ENV === 'production' || process.env.VUE_APP_SEND_DEV_LOGS) {
  window.addEventListener('error', function (event) {
    const msg = event?.error?.stack || event?.message;
    errorHandler('shell')(msg);
  });
}
